import { createSelector } from "@reduxjs/toolkit";

import type { ViewReducerState } from "./types";

export const getViewState = (state: { view: ViewReducerState }): ViewReducerState => state.view;

export const getMenuEntries = createSelector(getViewState, (state) => state.appStructureNode);

export const getDisplayFlyout = createSelector(getViewState, (state) => state.displayFlyout);
